import { takeLeading } from 'redux-saga/effects';
import { resourceSagaUtils, resourceStoreTypes } from '../core';

import * as actions from './investmentTWRRActions';
import { mkInvestmentTWRR } from './investmentTWRRTypes';

export function* getInvestmentTWRRActionWatcher() {
  const config = resourceStoreTypes.mkQcsSyncResourceConfig({
    resourceName: 'investment time weighted rate of return',
    resourceBaseUrl: '/v2/investments/time-weighted-rate-of-return',
    successAction: actions.getInvestmentTWRRSuccess,
    failureAction: actions.getInvestmentTWRRFailure,
    transformResponseToResources: (response) =>
      response.data && response.data.resources && response.data.resources.map((data) => mkInvestmentTWRR(data)),
  });
  yield takeLeading(actions.getInvestmentTWRR, resourceSagaUtils.qcsSyncGetResources, config);
}

export default [getInvestmentTWRRActionWatcher];
